import axios from 'axios';
import { MOCK_POSTS } from './mockData';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const SITE_ID = process.env.REACT_APP_SITE_ID || 'catchingon';

// When no API URL is configured (local `yarn start` without a backend), run fully
// offline against local fixtures so dev never touches the production API.
// Production builds set REACT_APP_API_URL via .env.production, so this is false there.
const USE_MOCK = !process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: `${API_URL}/${SITE_ID}`,
  headers: { 'Content-Type': 'application/json' },
});

const mockOk = (data) => Promise.resolve({ data });

export const submitContact = (data) => {
  if (USE_MOCK) {
    console.info('[mock] submitContact (no request sent)', data);
    return mockOk({ ok: true });
  }
  return api.post('/contact', data);
};

export const subscribeEmail = (email) => {
  if (USE_MOCK) {
    console.info('[mock] subscribeEmail (no request sent)', email);
    return mockOk({ ok: true });
  }
  return api.post('/emails', { email });
};

export const fetchPosts = () => {
  if (USE_MOCK) return Promise.resolve(MOCK_POSTS);
  return api.get('/posts').then((r) => r.data);
};

export const fetchPost = (slug) => {
  if (USE_MOCK) {
    const post = MOCK_POSTS.find((p) => p.slug === slug);
    return post ? Promise.resolve(post) : Promise.reject(new Error('Not found'));
  }
  return api.get(`/posts/${slug}`).then((r) => r.data);
};

export { API_URL, SITE_ID };
